import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationServiceComponent } from '../utils/notification-service-component/notification-service-component';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor( private _snackBar: MatSnackBar ) { }

  public showSnackBar( context: string, message: string )
  {
    this._snackBar.open( message, '', {
      duration: 10000,
      panelClass: [context || SNACK_BAR_MESSAGE_TYPE.default],
      verticalPosition: 'top',
      horizontalPosition: 'end'
    } );
  }

  public showErrorMessages( messages: string[] )
  {
    this._snackBar.openFromComponent( NotificationServiceComponent,
      {
        data: messages,
        panelClass: [SNACK_BAR_MESSAGE_TYPE.error],
        duration: 10000, verticalPosition: 'top',
        horizontalPosition: 'end'
      } );
  }

  public showErrorMessage( message: string )
  {
    this.showSnackBar( SNACK_BAR_MESSAGE_TYPE.error, message );
  }

  public showSuccessMessage( message: string )
  {
    this.showSnackBar( SNACK_BAR_MESSAGE_TYPE.success, message );
  }

  public showSuccessMessages( messages: string[] )
  {
    this._snackBar.openFromComponent( NotificationServiceComponent,
      {
        data: messages,
        panelClass: [SNACK_BAR_MESSAGE_TYPE.success],
        duration: 10000, verticalPosition: 'top',
        horizontalPosition: 'end'
      } );
  }

  public showWarningMessage( message: string )
  {
    this.showSnackBar( SNACK_BAR_MESSAGE_TYPE.warning, message );
  }

  public showDefaultMessage( message: string )
  {
    this.showSnackBar( SNACK_BAR_MESSAGE_TYPE.default, message );
  }

  public showServiceFailureMessage( serviceName: string, error: ErrorEvent )
  {
    const errorMessage = error.message ? error.message : error.error.message;
    const errorLabel = `${serviceName} service has failed: ${errorMessage}`;
    this.showErrorMessage( errorLabel );
  }

}

export enum SNACK_BAR_MESSAGE_TYPE
{
  success = 'green-success-snackbar',
  warning = 'orange-warning-snackbar',
  error = 'red-error-snackbar',
  default = 'default-snackbar'
}
